import React from "react";
import classnames from "classnames";

// Recetarios disponibles del médico; en cero se resalta para comprar más.
export default function PrescriptionAvailability({ amount }) {
  const total = Number(amount) || 0;

  return (
    <span
      className={classnames("doctor-office-prescriptions", {
        "is-empty": !total,
      })}
      title="Recetarios disponibles"
    >
      <i className="fa fa-file-text-o" aria-hidden="true"></i>
      <span>Recetarios disponibles:</span>
      <strong>{total.toLocaleString()}</strong>
    </span>
  );
}
